// extracted by mini-css-extract-plugin
export default {"simpleError":"SimpleError_simpleError__gzsLu"};